import React, { useEffect, useState } from "react";
import logo from "../asset/logowhite.png";
import instructorbg from "../asset/instructor/instructorbg.png";
import instructorcardbg from "../asset/instructorframe.png";
import { MdLocationOn } from "react-icons/md";
import { FaArrowLeft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

import {
  FaStar,
  FaUsers,
  FaLinkedin,
  FaTwitter,
  FaGithub,
  FaMoon,
  FaSun,
} from "react-icons/fa";
import { HiOutlineLibrary } from "react-icons/hi";
import SummaryApi from "../common";
import noimage from "../asset/noimage.png";

const AllInstructors = () => {
  const [profiles, setProfiles] = useState([]);
  const [loading, setLoading] = useState(true);
  const [darkMode, setDarkMode] = useState(false);
const [showFullSkills, setShowFullSkills] = useState(false);
const navigate = useNavigate();
  // Initialize dark mode from localStorage only
  useEffect(() => {
    const savedTheme = localStorage.getItem("theme");
    const shouldBeDark = savedTheme === "dark";
    setDarkMode(shouldBeDark);
  }, []);

  // Apply dark mode to document
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem("theme", "dark");
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem("theme", "light");
    }
  }, [darkMode]);

  // Toggle dark mode
  const toggleDarkMode = () => {
    const newDarkMode = !darkMode;
    setDarkMode(newDarkMode);
    
    // Dispatch event to sync all components
    window.dispatchEvent(new Event("themeChanged"));
  };

  // Listen for theme changes from other components
  useEffect(() => {
    const handleThemeChange = () => {
      const savedTheme = localStorage.getItem("theme");
      const shouldBeDark = savedTheme === "dark";
      setDarkMode(shouldBeDark);
    };

    window.addEventListener("themeChanged", handleThemeChange);
    
    return () => {
      window.removeEventListener("themeChanged", handleThemeChange);
    };
  }, []);

const handleCardClick = (instructor_id, e) => {
  if (e.target.closest("a")) return;

  // const studentId = localStorage.getItem("student_id");

  // if (!studentId) {
  //   Swal.fire({
  //     icon: "warning",
  //     title: "Please Login",
  //     text: "You need to login as a student before enrolling.",
  //     confirmButtonColor: "#3085d6",
  //     confirmButtonText: "OK",
  //   }).then((result) => {
  //     if (result.isConfirmed) {
  //       navigate("/student-login", { replace: true });
  //     }
  //   });
  //   return;
  // }

navigate(`/user-instructor?instructor_id=${instructor_id}`);


};
useEffect(() => {
  fetch(SummaryApi.getActiveInstructors.url)
    .then((res) => res.json())
    .then((data) => {
      if (data.status && Array.isArray(data.data)) {
        // Filter only verified instructors (is_otp_verification === 1)
        const verifiedProfiles = data.data
          .filter((instructor) => instructor.is_otp_verification === 1)
          .map((instructor) => {
            // Function to extract text from HTML skills
            const extractSkillsFromHTML = (skillsHTML) => {
              if (!skillsHTML || skillsHTML === "N/A" || skillsHTML === "<p>N/A</p>") {
                return [];
              }
              
              // Create a temporary DOM element to parse HTML
              const tempDiv = document.createElement('div');
              tempDiv.innerHTML = skillsHTML;
              
              // Extract text content from list items
              const listItems = tempDiv.querySelectorAll('li');
              if (listItems.length > 0) {
                return Array.from(listItems).map(li => li.textContent.trim());
              }
              
              // If no list items found, try to split by commas as fallback
              const textContent = tempDiv.textContent.trim();
              if (textContent && textContent !== "N/A") {
                return textContent.split(',').map(skill => skill.trim()).filter(skill => skill);
              }
              
              return [];
            };

            return {
                  instructor_id: instructor.instructor_id,
              name: `${instructor.first_name} ${instructor.last_name}`,
              title: instructor.job_title || "Instructor",
              location: instructor.address || "Location not specified",
              rating: parseFloat(instructor.rating) || 0,
     students: instructor.student_count,
              courses: instructor.course_count,
              about_instructor1:
                instructor.about_instructor1 || "No about_instructor1 provided",
              skills: extractSkillsFromHTML(instructor.skills),
              experience: instructor.total_experience
                ? `${instructor.total_experience}+ years Experience`
                : "Experience not specified",
              img: instructor.instructor_image
                ? `${SummaryApi.instructorCourseImage.url.replace("api", "")}${
                    instructor.instructor_image
                  }`
                : noimage,
            };
          });

        setProfiles(verifiedProfiles);
      } else {
        setProfiles([]);
      }
    })
    .catch((err) => {
      console.error("Failed to fetch instructors:", err);
      setProfiles([]);
    })
    .finally(() => {
      setLoading(false);
    });
}, []);
  const ProfileCard = ({
      instructor_id, 
    name,
    title,
    location,
    rating,
    students,
    courses,
    about_instructor1,
    skills,
    experience,
    img,
  }) => {
    return (
  <div
onClick={(e) => handleCardClick(instructor_id, e)}
  className="relative rounded-xl w-full sm:w-[90%] md:w-[80%] lg:w-[90%] xl:w-full p-6 flex flex-col items-center font-inter mx-auto bg-white border border-gray-200 shadow-lg dark:bg-gray-800 dark:border-gray-700 dark:shadow-gray-900/50 cursor-pointer"
  style={{ minHeight: "620px" }}
>
        <div className="relative z-10 mt-[-15%]">
          <img
            src={img}
            alt={name}
            className="w-24 h-24 rounded-full border-4 border-white shadow-md object-cover dark:border-gray-600"
          />
          <div className="absolute right-7 bg-green-600 text-white text-[10px] font-semibold px-3 py-1 rounded-full shadow-lg -translate-y-1/2 translate-x-1/4 dark:bg-green-500">
            VERIFIED
          </div>
        </div>

        <div className="relative z-10 w-full text-center">
          <h3 className="mt-6 font-semibold text-lg text-gray-900 font-inter text-center dark:text-white">
            {name}
          </h3>
          <p className="text-blue-600 font-semibold text-sm mt-1 cursor-pointer hover:underline font-inter text-center dark:text-blue-400">
            {title}
          </p>


<div
  className="flex items-center justify-center text-gray-600 text-[12px] mt-2 w-full dark:text-gray-300"
>
  <MdLocationOn className="flex-shrink-0" />
  <span 
    className="line-clamp-1 ml-0"
    style={{
      display: "-webkit-box",
      WebkitLineClamp: 1,
      WebkitBoxOrient: "vertical",
      overflow: "hidden",
    }}
  >
    {location}
  </span>
</div>
        </div>

        {/* Ratings, students, courses */}
        <div className="relative z-10 flex justify-around items-center bg-gray-50 py-4 px-2 mt-4 rounded-lg shadow-md border border-gray-100 text-[10px] text-gray-800 w-full max-w-xs dark:bg-gray-700 dark:border-gray-600 dark:text-gray-300">
  <div className="flex flex-col items-center">
    <div className="flex items-center space-x-1">
      <FaStar className="w-4 h-4 text-yellow-400" />
      <b>{rating}</b>
    </div>
    <span className="text-gray-600 text-[12px] dark:text-gray-300">Rating</span>
  </div>
  <div className="flex flex-col items-center">
    <div className="flex items-center space-x-1">
      <FaUsers className="w-4 h-4 text-blue-500 dark:text-blue-400" />
      <b>{students}</b>
    </div>
    <span className="text-gray-600 text-[12px] dark:text-gray-300">Students</span>
  </div>
  <div className="flex flex-col items-center">
    <div className="flex items-center space-x-1">
      <HiOutlineLibrary className="w-4 h-4 text-green-600 dark:text-green-400" />
      <b>{courses}</b>
    </div>
    <span className="text-gray-600 text-[12px] dark:text-gray-300">Courses</span>
  </div>
</div>

        {/* Description */}
        <div className="relative z-10 w-full">
          <p
            className="text-center text-sm text-gray-700 mt-4 line-clamp-2 w-full px-2 dark:text-gray-300"
            style={{
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              minHeight: "3em", 
            }}
          >
            {about_instructor1}
          </p>
        </div>

        {/* Skills */}
{/* Skills - Responsive Layout with Tailwind */}
<div
  className="relative z-10 mt-5 w-full flex-1 overflow-hidden"
  style={{ minHeight: "60px" }}
>
  {skills.length > 0 ? (
    <ul className="grid grid-cols-1 sm:grid-cols-2 gap-2 p-0 m-0 list-none w-full px-2">
      {skills.map((skill, idx) => (
<li
  key={idx}
  className="bg-blue-100 font-semibold rounded px-3 py-1.5 flex items-center justify-start shadow-sm border border-blue-200 dark:bg-gray-700 dark:border-gray-600 min-h-[34px]"
>
  <span className="text-blue-600 font-bold dark:text-gray-300 flex-shrink-0 text-sm mr-2">
    •
  </span>

<span className="text-gray-800 dark:text-gray-200 text-[10px] sm:text-[11px] md:text-[12px] lg:text-[13px] xl:text-sm whitespace-nowrap overflow-hidden text-ellipsis">
    {skill}
</span>
</li>

      ))}
    </ul>
  ) : (
    <p className="text-gray-500 text-xs text-center dark:text-gray-400">No skills listed</p>
  )}
</div>
        {/* Social Links */}
        <div className="relative z-10 flex justify-center space-x-6 text-blue-600 mt-6 text-xl dark:text-blue-400">
          <a href="#" aria-label="LinkedIn" className="hover:text-blue-800 dark:hover:text-blue-300 transition-colors">
            <FaLinkedin />
          </a>
          <a href="#" aria-label="Twitter" className="hover:text-blue-800 dark:hover:text-blue-300 transition-colors">
            <FaTwitter />
          </a>
          <a href="#" aria-label="GitHub" className="hover:text-blue-800 dark:hover:text-blue-300 transition-colors">
            <FaGithub />
          </a>
        </div>

        {/* Experience */}
        <p className="relative z-10 text-gray-600 text-[12px] mt-5 text-center dark:text-gray-300">{experience}</p>

<button
  onClick={(e) => {
    e.stopPropagation();  // prevent card click event
    handleCardClick(instructor_id, e);
  }}
  className="relative z-10 mt-auto bg-[#1C3664] text-white text-center text-sm font-semibold py-1 px-6 rounded-lg hover:bg-blue-800 transition w-[80%] block dark:bg-blue-600 dark:hover:bg-blue-700"
  style={{ marginTop: "auto" }}
>
  View Profile
</button>

      </div>
    );
  };

  if (loading) {
    return (
      <div className="text-center py-12 text-gray-500 font-inter dark:text-gray-400 bg-white dark:bg-gray-900 min-h-screen">
        Loading instructors...
      </div>
    );
  }

  return (
<div className="bg-white dark:bg-gray-900 min-h-screen transition-colors duration-300 relative">
      {/* Back Button - Only show on responsive devices (hidden on lg and larger) */}
      <button
        onClick={() => window.history.back()}
        className="fixed top-24 left-4 z-[60] flex items-center justify-center w-12 h-12 bg-white rounded-full shadow-lg hover:shadow-xl transition-all border border-gray-200 dark:bg-gray-800 dark:border-gray-700 lg:hidden"
        aria-label="Go back"
      >
        <FaArrowLeft className="text-2xl text-[#103b6b] dark:text-white" />
      </button>

      {/* Header Section */}
      <div className="bg-[#103b6b] py-12 px-4 text-center text-white rounded-lg dark:bg-gray-800">
        <div className="text-[#4384cd] font-semibold py-3 px-8 rounded-full shadow-lg border-[3px] border-[#4384cd] w-full md:w-[25%] mx-auto mb-5 dark:border-blue-400 dark:text-blue-300">
          World-Class Faculty
        </div>
        
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-extrabold mb-2 font-inter">
          Meet Our Expert Instructors
        </h2>

        <p className="text-sm mb-12 max-w-xl mx-auto font-inter dark:text-gray-300">
          Learn from industry professionals, certified experts, and thought
          leaders who bring real-world experience to every lesson
        </p>

        <div className="flex flex-col sm:flex-row justify-center space-y-8 sm:space-y-0 sm:space-x-12 text-yellow-400 font-inter">
          <div className="text-center">
            <div className="text-3xl font-extrabold text-yellow-400">50+</div>
            <div className="font-semibold text-white dark:text-gray-300">Expert Instructors</div>
          </div>

          <div className="text-center font-inter">
            <div className="text-3xl font-extrabold text-yellow-400 flex items-center justify-center space-x-1">
              <span>4.8</span>
              <FaStar />
            </div>
            <div className="font-semibold text-white dark:text-gray-300">Average Rating</div>
          </div>

          <div className="text-center font-inter">
            <div className="text-3xl font-extrabold text-yellow-400">500k+</div>
            <div className="font-semibold text-white dark:text-gray-300">Students Taught</div>
          </div>
        </div>
      </div>

      {/* Instructors Grid */}
      <div className="flex items-center justify-center bg-gray-50 py-12 px-4 dark:bg-gray-900">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto px-4">
          {profiles.length > 0 ? (
            profiles.map((profile, index) => (
              <ProfileCard key={`${profile.name}-${index}`} {...profile} />
            ))
          ) : (
            <div className="col-span-full text-center text-gray-500 dark:text-gray-400 py-8">
              No verified instructors found.
            </div>
          )}
        </div>
      </div>

      {/* Footer CTA Section */}
      <div
        className="text-center py-16 px-6 dark:bg-gray-800 relative"
        style={{
          backgroundImage: `url(${instructorbg})`,
        }}
      >
        <div className="absolute inset-0 bg-blue-900 dark:bg-gray-900 opacity-90"></div>
        
        <div className="relative z-10">
          <h2 className="text-white font-semibold text-[24px] font-inter mb-4">
            Ready to Learn from the Best?
          </h2>
          <p className="text-white mb-6 dark:text-gray-300">
            Join thousands of students learning from industry experts and
            accelerate your career growth
          </p>
        <div className="flex flex-col sm:flex-row justify-center items-center gap-3 mb-16">
  <a
    href="/all-courses"
    className="bg-white text-blue-900 font-semibold rounded px-4 py-1.5 hover:bg-gray-100 transition dark:bg-gray-700 dark:text-white dark:hover:bg-gray-600 text-sm text-center min-w-[140px] flex items-center justify-center"
  >
    Browse All Courses
  </a>
  <button className="border border-white text-white font-semibold rounded px-4 py-1.5 hover:bg-white hover:text-blue-900 transition dark:border-gray-400 dark:text-gray-300 dark:hover:bg-gray-700 dark:hover:text-white text-sm text-center min-w-[140px] flex items-center justify-center">
    Become An Instructor
  </button>
</div>
          <div className="inline-block mb-12">
            <img src={logo} className="mx-auto w-3/4 sm:w-1/2 md:w-1/3" alt="Skillara Logo" />
          </div>

          <h3 className="text-blue-300 font-extrabold text-3xl mb-4 dark:text-blue-400">
            Enroll, Learn, Grow, Repeat!
          </h3>
          <p className="text-white mb-6 text-lg dark:text-gray-300">
            Get ready to achieve your learning goals with Skillara
          </p>

          <a
            href="/all-courses"
            className="inline-block bg-blue-900 hover:bg-blue-800 text-white rounded-full px-8 py-3 font-semibold transition dark:bg-blue-700 dark:hover:bg-blue-600"
          >
            View All Premium Courses
          </a>
        </div>
      </div>
    </div>
  );
};

export default AllInstructors;